// @ts-nocheck

import { createSelector } from 'reselect';

import {
  selectMultiviewDisplayOptions,
  selectMultiviewItemPerLine,
  selectMultiviewUserOption,
} from '../../selectors/multiview/multiviewPrimary.selector';
import { type Selector } from '../../types/selectors';

type MultiviewControllerPropsType = {
  displayOptions: Array<number>;
  itemPerLine: number;
  userOption: number;
};

const selectMultiviewControllerProps: Selector<MultiviewControllerPropsType> = createSelector(
  [selectMultiviewDisplayOptions, selectMultiviewItemPerLine, selectMultiviewUserOption],
  (displayOptions, itemPerLine, userOption) => ({
    displayOptions,
    itemPerLine,
    userOption,
  }),
);

export default selectMultiviewControllerProps;
